import { useState } from 'react';

// Whether the focus is in an element or anything inside it, with the onFocus, onBlur and onMouseDown to put on
// it. Leaving for another window or tab doesn't count: the focus comes back where it was. A press on a part of
// it that can't take the focus, such as the space between toolbar buttons, leaves the focus where it is.
export function useFocusWithin() {
    const [focused, setFocused] = useState(false);
    const handlers = {
        onFocus: () => setFocused(true),
        onBlur: (e) => {
            if (e.currentTarget.contains(e.relatedTarget) || !document.hasFocus()) return;
            setFocused(false);
        },
        onMouseDown: (e) => {
            if (!e.target.closest('input, textarea, [contenteditable="true"]')) e.preventDefault();
        },
    };
    return [focused, handlers];
}
